export default "__VITE_ASSET__BMfZ1D8E__"